<template>
    <div>
        <main class="layoutContent">
                <!-- Encabezado contenido principal -->
                <header class="page-header">
                    <div class="container pt-2">
                        <div class="row align-items-center justify-content-between">
                            <div class="col-auto pt-1">
                                <h1 class="page-header--title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        class="bi bi-file-earmark-text" viewBox="0 0 16 16">
                                        <path
                                            d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
                                        <path
                                            d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                    </svg>
                                    Solicitudes {{ plan }}
                                </h1>
                                <p class="page-header--subtitle">
                                    Plan de vacaciones
                                </p>
                            </div>
                            <div class="col-12 col-xl-auto mt-4">
                                <div class="text-right">
                                    <!-- <div class="text-white">Solicitud <span class="ml-2 p-2 page-header--title">{{ solicitud }}</span></div>
                                    <p class="page-header--subtitle">Fecha<span class="ml-2 p-2 font-weight-bold ">{{ fechasol }}</span></p> -->
                                </div>

                            </div>
                        </div>
                    </div>
                </header>
                <!-- Fin encabezado contenido principal -->

                <!-- Cuerpo contenido principal -->
                <div class="container content-body">
                    <div class="row">
                        <!-- Bloque Personas-->
                        <div class="col-xl-4 mb-2">

                            <!-- Datos Solicitante -->
                            <div class="card mb-2">
                                <div class="card-header">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                        class="bi bi-box" viewBox="0 0 16 16">
                                        <path
                                            d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                    </svg>
                                    Datos del solicitante
                                </div>
                                <div class="card-body">
                                    <div class="form-row">
                                        <div class="form-group col-12">
                                            <label>Dirección</label>
                                            <input class="form-control" type="text" placeholder="Dirección" :disabled="!edicion" v-model="EMP.dir"/>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-3">
                                            <input class="form-control" type="text" placeholder="Cod.Postal" :disabled="!edicion" v-model="EMP.cpo"/>
                                        </div>
                                        <div class="form-group col-9">
                                            <input class="form-control" type="text" placeholder="Población" :disabled="!edicion" v-model="EMP.pob"/>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-12">
                                            <input class="form-control" type="text" placeholder="Provincia" :disabled="!edicion" v-model="EMP.pro"/>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col">
                                            <label>Tel. Trabajo</label>
                                            <input class="form-control" type="text" :disabled="!edicion" v-model="EMP.tfnot"/>
                                        </div>
                                        <div class="form-group col">
                                            <label>Particular</label>
                                            <input class="form-control" type="text" :disabled="!edicion" v-model="EMP.tfnop"/>
                                        </div>
                                        <div class="form-group col">
                                            <label for="telMovil">Móvil</label>
                                            <input class="form-control" type="text" :disabled="!edicion" v-model="EMP.tfnom"/>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <label for="email">Email</label>
                                            <input class="form-control" type="text" :disabled="!edicion" v-model="EMP.email"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Datos solicitante -->

                        </div>

                        <!-- Bloque Asistentes, Solicitud (Establecimientos y Observaciones) -->
                        <div class="col-xl-8 mb-2">

                        <div v-if="!edicion">
                            <!-- Card Datos solicitante -->
                            <div class="card mb-2">
                                <div class="card-header d-flex flex-column flex-sm-row align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                        class="mr-1 bi bi-box" viewBox="0 0 16 16">
                                        <path
                                            d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                    </svg>
                                    Asistentes / Hijos
                                    <!-- Botones -->
                                    <div class="icons-actions ml-auto">
                                        <b-button variant="success" size="sm" class="mt-1 mr-1" @click="nuevo">
                                            <b-icon icon="check-circle" variant="light" aria-hidden="true"></b-icon> NUEVA
                                        </b-button>
                                        <b-button variant="dark" size="sm" class="mt-1 mr-1" @click="cerrar">
                                            <b-icon icon="x-circle" variant="light" aria-hidden="true"></b-icon> Cerrar
                                        </b-button>
                                        <!-- <b-button variant="success" size="sm" class="mt-1 mr-1" @click="editar" v-if="solicita.items.length>0">
                                            <b-icon icon="pen" variant="light" aria-hidden="true"></b-icon> EDITAR
                                        </b-button> -->

                                    </div>
                                </div>
                                <!-- Grid Solicitudes -->
                                <div class="my-1">
                                    <b-card class="p-1">
                                        <!-- <div class="card-header border-bottom-0">Establecimientos encontrados</div>                                 -->
                                        <b-table striped hover sticky-header="300px"
                                            selectable select-mode="single" @row-selected="selecciona"
                                            :items="solicita.items" :fields="solicita.fields"
                                            class="table-responsive-md bg-white p-1" responsive="sm">
                                        </b-table>
                                        <p v-if="solicita.items.length>1"><small>Solicitudes </small> <b> {{solicita.items.length}} </b> <small> *** Para Ver / Editar debes seleccionar el Asistente </small> </p>
                                    </b-card>

                                </div>
                            </div>
                            <div class="card mb-2" v-if="SS.nom>''">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            Solicitud - <b>{{ SS.nom }}</b>
                                        </div>
                                        <div class="col-sm-6 text-right" v-show="SS.std=='1'">
                                            <b-button-group size="sm">
                                                <b-button variant="outline-primary" @click="editar">
                                                    <b-icon icon="pencil-square"></b-icon>Editar
                                                </b-button>
                                                <b-button variant="outline-primary" @click="pdf">
                                                    <b-icon icon="printer-fill"></b-icon>PDF
                                                </b-button>
                                                <b-button variant="outline-primary" @click="anular">
                                                    <b-icon icon="x-circle"></b-icon> Anular
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <!-- 1 -->
                                    <div class="accommodation mb-1">
                                         <h5 class="font-weight-bold text-center mt-3" :style="estilo_estado">
                                            {{ SS.estado }}
                                        </h5>
                                        <div class="form-group row">
                                            <div class="col-sm-9 px-2">
                                                <label for="establecimiento" class="col-form-label col-form-label-sm">Establecimiento</label>
                                                <input disabled type="text" class="form-control" v-model="SS.s1hotel" />
                                            </div>
                                            <div class="col-sm-3 pl-0">
                                                <label class="col-form-label col-form-label-sm">Periodo</label>
                                                <input disabled type="text" class="form-control" v-model="SS.s1per" />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-sm-9 px-2">
                                                <input disabled type="text" class="form-control" v-model="SS.s2hotel" />
                                            </div>
                                            <div class="col-sm-3 pl-0">
                                                <input disabled type="text" class="form-control" v-model="SS.s2per" />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-sm-9 px-2">
                                                <input disabled type="text" class="form-control" v-model="SS.s3hotel" />
                                            </div>
                                            <div class="col-sm-3 pl-0">
                                                <input disabled type="text" class="form-control" v-model="SS.s3per" />
                                            </div>
                                        </div>

                                    </div>
                                    <!-- 1 -->
                                    <div class="accommodation mb-1">
                                        <div class="form-group row">
                                            <div class="col-sm-12 px-2">
                                                <label for="establecimiento" class="col-form-label col-form-label-sm">Observaciones</label>
                                                <textarea disabled class="mx-1 my-1 form-control" cols="30" rows="2" v-model="SS.sobs"/>
                                            </div>
                                        </div>

                                    </div>


                                </div>
                            </div>
                        </div>

                        <div v-if="edicion">
                            <!-- Card Datos solicitante -->
                            <div class="card mb-2">
                                <div class="card-header d-flex flex-column flex-sm-row align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                        class="mr-1 bi bi-box" viewBox="0 0 16 16">
                                        <path
                                            d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                    </svg>
                                    Solicitud Asistente/Hijo
                                    <!-- Botones -->
                                    <div class="icons-actions ml-auto">
                                        <b-button variant="dark" size="sm" class="mt-1 mr-2" @click="cancelar">
                                            <b-icon icon="x-circle" variant="light" aria-hidden="true"></b-icon> Cancelar
                                        </b-button>
                                        <b-button variant="success" size="sm" class="mt-1 mr-2" @click="grabar">
                                            <b-icon icon="check-circle" variant="light" aria-hidden="true"></b-icon> GRABAR
                                        </b-button>

                                    </div>
                                </div>

                                <div class="card-body">
                                    <div class="box mb-0">
                                        <div class="box-content p-1 ">

                                            <!-- Solicitante -->
                                            <div class="form-row">
                                                <div class="form-group col-5">
                                                    <label for="nombreSolicitante">Apellidos, Nombre</label>
                                                    <input class="form-control col" id="nombreSolicitante" type="text"
                                                        placeholder="Nombre Asistente" v-model="SS.nom"/>
                                                </div>
                                                <div class="form-group col-2">
                                                    <label>DNI</label>
                                                    <b-form-input class="form-control" type="text" placeholder="DNI/Nif" v-model="SS.nif"/>
                                                </div>
                                                <div class="form-group col-2">
                                                    <label for="matricula">Sexo</label>
                                                    <!-- <b-form-input class="form-control" type="text" v-model="SS.sexo"/> -->
                                                    <b-form-select :options="sexo" size="sm" v-model="SS.sexo"></b-form-select>
                                                </div>
                                                <div class="form-group col-2">
                                                    <label for="matricula">Edad</label>
                                                    <!-- <b-form-input class="form-control" type="text" v-model="SS.edad"/> -->
                                                    <b-form-select :options="edad" size="sm" v-model="SS.edad"></b-form-select>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- Fin Card Datos solicitante -->

                            <!-- Establecimientos -->
                            <div class="card mb-1">
                                <div class="card-header d-flex align-items-center">Establecimientos
                                    <div class="icons-actions ml-auto">
                                        <b-button variant="secondary" size="sm" class="mt-1 mr-2" @click="precios">
                                            <b-icon icon="credit-card-fill" variant="light" aria-hidden="true"></b-icon> Precios
                                        </b-button>
                                    </div>
                                </div>
                                <div class="card-body pt-1 px-1">

                                    <!-- 1 -->
                                    <div class="accommodation mb-1">
                                        <div class="form-group row">
                                            <label for="establecimiento"
                                                class="col-2 col-form-label col-form-label-sm">Establecimiento</label>
                                            <div class="col-10">
                                                 <b-form-select v-model="SS.s1h" value-field="id" text-field="name"
                                                    @change="hotel_change(1)"
                                                    :options="itemsHot"
                                                    class="mb-1 form-control"
                                                ></b-form-select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label col-form-label-sm">
                                                Periodo : Tipo
                                                <!-- <b-icon button class="mr-2 h6" variant="primary" icon="info-circle"
                                                    @click="turno_info(1)" v-show="SS.s1>''">
                                                </b-icon> -->
                                            </label>
                                            <div class="col-sm-6">
                                                <b-form-select v-model="SS.s1" value-field="id" text-field="per"
                                                    @change="turno_change(1)"
                                                    :options="itemsPer1"
                                                    class="mb-0 form-control"
                                                ></b-form-select>
                                            </div>
                                            <div class="col-sm-2">
                                                {{ SS.s1pp }}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 2 -->
                                    <div class="accommodation mb-1">
                                        <div class="form-group row" disabled>
                                            <label for="establecimiento"
                                                class="col-sm-2 col-form-label col-form-label-sm">Establecimiento</label>
                                            <div class="col-sm-10">
                                                 <b-form-select v-model="SS.s2h" value-field="id" text-field="name" :disabled="!SS.s1h>''"
                                                    @change="hotel_change(2)"
                                                    :options="itemsHot"
                                                    class="mb-1 form-control"
                                                ></b-form-select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label col-form-label-sm">
                                                Periodo : Tipo
                                            </label>
                                            <!-- <div class="col-sm-4"> -->
                                            <div class="col-sm-6">
                                                <b-form-select v-model="SS.s2" value-field="id" text-field="per" :disabled="!SS.s2h>''"
                                                    @change="turno_change(2)"
                                                    :options="itemsPer2"
                                                    class="mb-0 form-control"
                                                ></b-form-select>
                                            </div>
                                            <div class="col-sm-2">
                                                {{ SS.s2pp }}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 3 -->
                                    <div class="accommodation mb-1">
                                        <div class="form-group row">
                                            <label for="establecimiento"
                                                class="col-sm-2 col-form-label col-form-label-sm">Establecimiento</label>
                                            <div class="col-sm-10">
                                                 <b-form-select v-model="SS.s3h" value-field="id" text-field="name" :disabled="!SS.s2h>''"
                                                    @change="hotel_change(3)"
                                                    :options="itemsHot"
                                                    class="mb-1 form-control"
                                                ></b-form-select>
                                                <!-- <input type="text" disabled class="form-control" v-model="SS.s1hot"/> -->
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label col-form-label-sm">
                                                Periodo : Tipo
                                                <b-btn disabled size="sm" class="ml-2"><b-icon icon="search" @click="buscar(1)"></b-icon></b-btn>
                                            </label>
                                            <!-- <div class="col-sm-4"> -->
                                            <div class="col-sm-6">
                                                <b-form-select v-model="SS.s3" value-field="id" text-field="per" :disabled="!SS.s3h>''"
                                                    @change="turno_change(3)"
                                                    :options="itemsPer3"
                                                    class="mb-0 form-control"
                                                ></b-form-select>
                                            </div>
                                            <div class="col-sm-2">
                                                {{ SS.s3pp }}
                                            </div>
                                            <!-- <div class="form-inline col-sm-6"> -->
                                            <div class="form-inline col-sm-4">
                                                <div class="form-group mr-2">

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">Observaciones</div>
                                <textarea class="mx-2 my-2 form-control" cols="30" rows="2" v-model="SS.sobs"/>
                                <div class="card-body">
                                    <p><small>
                                        Para acceso a Solicitudes ADJUDICADAS vea Menú Reservas.
                                        Desde ese apartado podrá ver e imprimir la
                                        documentación de la misma. En caso de NO ADJUDICADA o
                                        CANCELADA, deberá ir a VACANTES para ver los
                                        establecimientos y periodos disponibles.</small>
                                    </p>
                                </div>
                            </div>
                            <!-- {{ SS }} -->
                        </div>
                        <!-- fin solicitud -->
                        </div>
                    </div>
                </div>
                <!-- Fin Cuerpo contenido principal -->
            </main>
    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'solicitar_campamentos',

 /*  props: {
        datos: { type:Object, default: null},
  }, */

  data() {
    return {
        plan: 'CAMPAMENTOS',
        planId: 2,

        edicion: false,

        sexo:[
            {value:'H', text:'Hombre'},
            {value:'M', text:'Mujer'},
        ],
        edad:[
            {value:'3', text:'3'},
            {value:'4', text:'4'},
            {value:'5', text:'5'},
            {value:'6', text:'6'},
            {value:'7', text:'7'},
            {value:'8', text:'8'},
            {value:'9', text:'9'},
            {value:'10', text:'10'},
            {value:'11', text:'11'},
            {value:'12', text:'12'},
            {value:'13', text:'13'},
            {value:'14', text:'14'},
            {value:'15', text:'15'},
            {value:'16', text:'16'},
            {value:'17', text:'17'},
            {value:'18', text:'18'},
            {value:'19', text:'18'},
            {value:'20', text:'19'},
            {value:'21', text:'21'},
        ],
        tpe: 0,

        itemsHot:  [],
        itemsPer1: [],
        itemsPer2: [],
        itemsPer3: [],

        SS: {},

        solicita: {
            items: [],
            fields: [
                { key:'nom',label:'Nombre'},
                { key:'nif',label:'DNI'},
                { key:'sexo',label:'Sexo'},
                { key:'edad',label:'Edad'},
            ],
        },

    }
  },

  created() {
  },

  mounted() {
      this.leemos();

      //this.SS=this.SOL;
  },

  computed: {
    ...mapState(['auth','fecha','EMP','ASI','SOL','G']),

    logueado() {
        return this.auth.logueado;
    },
    usuario() {
        return this.auth.user;
    },

    solicitud() {
        return this.SS.id>0 ? this.SS.id : 'NUEVA';
    },

    fechasol() {
        return !this.SS.fecha>'' ? this.fecha : this.SS.fecha;

    },

    //recuento
    PAX() {
        let Y=new Date().getFullYear();
        let p=1; let a=1; let n=0; let b=0; let aa=0; let nn=0;
        this.ASI.forEach(E => {
            if (Number(E.anac)>=Y-1) b++;
            else {
                p++;
                if (Number(E.anac)>=Y-12) n++; else a++;
                if (E.tp=='1') if (Number(E.anac)>=Y-12) nn++; else aa++;
            }
        });
        return {pax: p, adu: a, nin: n, bbs: b, adug: aa, ning: nn };
    },

    estilo_estado() {
        let a=['black','blue','green','red'];
        return "color: " + a[this.SS.std];
    }

  },

  methods: {
       ...mapMutations(['loading','alerta','modal']),
       ...mapActions(['exec']),

       async solicitudes() {
            var args={ token: this.auth.token, fnt:'get', plan: this.planId }
            let r=await this.exec({api:'solicitud', arg: args });

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                this.modal({tit: this.plan, msg: r.datos});

                this.$router.push('/inicio');
                return;
            }

            //guardamos datos
            this.$store.state.EMP=r.datos[0]; //Object.values(r.datos[0]);
            this.$store.state.ASI=Object.values(r.datos[1]);
            this.$store.state.SOL=r.datos[2];

            console.log('*****LEEMOS - solicitudes',this.EMP,this.ASI,this.SOL);
            //
            this.cancelar();
        },

       async leemos() {
            //this.loading();

            var args={ token: this.auth.token, plan: this.planId }
            let r=await this.exec({api:'hoteles_turnos', arg: args });

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                this.modal({tit:"SOLICITUDES", msg:r.datos});
                r.datos=[];
                return;
            }
            //guardamos datos
            this.itemsHot=Object.values(r.datos[0]);

            //this.loading(false);
            this.leido();
       },

       leido() {
            this.solicita.items=Object.values(this.SOL);
            this.SS=this.solicita.items[0];
            this.leemos0();
       },

       leemos0() {
            //if (!this.SS) return;

            let S=Object.assign({}, this.SS);
            //alert(S.s1);
            //this.SS=this.SOL;

            if (this.SS.s1>'0') this.hotel_change(1);
            if (this.SS.s2>'0') this.hotel_change(2);
            if (this.SS.s3>'0') this.hotel_change(3);

            //alert(S.s1);
            this.SS.s1=S.s1;
            this.SS.s2=S.s2;
            this.SS.s3=S.s3;

            if (this.SS.s1>'0') this.turno_change(1);
            if (this.SS.s2>'0') this.turno_change(2);
            if (this.SS.s3>'0') this.turno_change(3);
        },

        async releemos() {
            alert('adsfadf');
            if (await this.$emit('leemos')) {
                this.cancelar();
            }
        },


        selecciona(item) {
            console.log('**selecciona',item,typeof(item));

            this.SS=item[0];
            //this.leemos0();
        },

        //nueva solicitud
        nuevo() {
            this.edicion=true;
            this.SS={id:0,sexo:'M',edad:'14'};
        },

        editar() {
            this.edicion=true;
            this.leemos0();
        },

        cancelar() {
            this.edicion=false;
            //this.leemos();
            //await this.$emit('solicitudes');
            this.leido();
            console.log('***CANCELAR-LEIDO', this.SOL);
        },

        async anular() {
            let msg="Estas Seguro <b>ANULAR</b> Solicitud ?<br><b>" + this.SS.nom +"</b><br>Se eliminaran los establecimientos seleccionados";
            let r=await this.$root.$msgConf(msg, this.plan);
            if (!r) return;

            var args={ token: this.auth.token, fnt:'anular', id: this.SS.id }
            r=await this.exec({api:'solicitud', arg: args });

            if (!r.error)
                r.datos='Solicitud ANULADA';

            //guardamos datos
            this.modal({tit: this.plan, msg: r.datos});
            //this.$router.push('/campamentos');
            this.solicitudes();
        },

        pdf0() {
            let url="https://fondos-sociales.com/__a/sol1.php?arg=123|" + this.SS.id + '|9';
            let a=window.open(url,'blank');
            console.log(a);
        },

        async pdf() {
            var args={ token: this.auth.token, fnt: 'pdf', id: this.SS.id }
            let r=await this.exec({api:'solicitud', arg: args });

            if (r.error) {
                this.modal({tit: this.modulo, msg: r.datos});
                return;
            }
            let url=this.G.url_tmpW + r.datos;
            window.open(url,'blank');
        },

        //solicitud
        async grabar() {
            console.log('**grabamos',this.EMP,this.ASI,this.SOL,this.SS);

            if (!this.validar()) return;

            let msg="Estas Seguro GUARDAR Solicitud ?";
            let r=await this.$root.$msgConf(msg, this.plan);
            if (!r) return;

            this.SS.adu=0; this.SS.nin=1; this.SS.bbs=0;
            this.SS.adug=0; this.SS.ning=0;

            var args={ token: this.auth.token, plan: this.planId, fnt:'set', EMP: this.EMP, SOL: this.SS, ASI: this.ASI  }
            r=await this.exec({api:'solicitud', arg: args });

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                this.modal({tit: this.plan, msg: r.datos});
                return;
            }
            //guardamos datos
            //this.itemsHot=Object.values(r.datos[0]);
            //this.loading(false);

            this.modal({tit: this.plan, msg: 'Solicitud Guardada Correctamente'});
            //this.$router.push('/campamentos');
            //this.$emit('leido');
            this.solicitudes();
        },

        validar() {
            let S=this.SS;
            let e1=0; let e2=0;

            let msg='';
            //asistente
            if (!S.nom>'') msg+="<br>*Falta Apellidos, Nombre del Asistente";
            if (!S.nif>'') msg+="<br>*Falta DNI/NIF del Asistente";

            if (!S.s1>'') msg+='<br>(1) Debes seleccionar un Establecimiento al menos';

            if (S.s1pp!=undefined) {
                e1=Number(S.s1pp.split('-')[0]);
                e2=Number(S.s1pp.split('-')[1]);
                if (Number(S.edad)<e1||Number(S.edad)>e2)
                    msg+='<br>(1) Edad No Permitida en este establecimiento ( Edad entre ' +S.s1pp+' años )';
            }

            if (S.s2pp!=undefined) {
                e1=Number(S.s2pp.split('-')[0]);
                e2=Number(S.s2pp.split('-')[1]);
                if (Number(S.edad)<e1||Number(S.edad)>e2)
                    msg+='<br>(2) Edad No Permitida en este Establecimiento ( Edad entre ' +S.s2pp+' años )';
            }

            if (S.s3pp!=undefined) {
                e1=Number(S.s3pp.split('-')[0]);
                e2=Number(S.s3pp.split('-')[1]);
                if (Number(S.edad)<e1||Number(S.edad)>e2)
                    msg+='<br>(3) Edad No Permitida en este establecimiento ( Edad entre ' +S.s3pp+' años )';
            }

            if (S.s2tp>0 && (S.s2==S.s1|| S.s2==S.s3)) msg+='<br>(2) No se puede seleccionar el mismo Establecimiento y Turno';
            if (S.s3tp>0 && (S.s3==S.s1||S.s3==S.s2)) msg+='<br>(3) No se puede seleccionar el mismo Establecimiento y Turno';

            if (msg>'') {
                //this.$root.$msgBox(msg,'SOLICITUDES VERANO');
                this.modal({tit: this.plan, msg: msg});
                return false;
            }
            return true;
        },

        //periodos
        buscar(p=1) {
            alert('busqueda' + p);

            this.$bvModal.show("modal_hotelTurnos");
        },

        cerrar() {
            //let u=(!this.SS.id>'' ? '/' : '/inicio');
            this.$router.push('/inicio');
        },

        hotel_change(v) {
            let h=this.SS['s' + v + 'h'];
            if (!h>'') return;
            let a=this.itemsHot.find(hotel => hotel.id==h);
            console.log('*hotel_change',v,h,a);

            let t=Object.values(a.turnos.datos[0]);

            if (v==1) this.itemsPer1=t;
            if (v==2) this.itemsPer2=t;
            if (v==3) this.itemsPer3=t;

            this.SS['s' + v]=t[0].id;
            this.SS['s' + v + 'tp']=t[0].tp;

            this.turno_change(v);
        },

        turno_change(v) {
            //alert(item);
            //let a=this.itemsPer.find(per => per.id==item);
            let P=(v==3 ? this.itemsPer3 : (v==2 ? this.itemsPer2 : this.itemsPer1));
            let x=this.SS['s' + v ];
            let a=P.find(per => per.id==Number(x));
            console.log('*turno_change',v,x,a);

            this.SS['s'+ v +'t']=a.tph;
            this.SS['s'+ v +'tx']=(a.tp==1?'Habit.':'Apart.');
            this.SS['s'+ v +'h1']=1;
            this.SS['s'+ v +'e']=a.fhe;
            this.SS['s'+ v +'s']=a.fhs;
            this.SS['s'+ v +'r']=a.reg;
            this.SS['s'+ v +'pp']=a.mpax;
            this.SS['s'+ v +'pa']=a.madu;
        },

        turno_info(v) {
            //alert(item);
            //let a=this.itemsPer.find(per => per.id==item);
            let P=(v==3 ? this.itemsPer3 : (v==2 ? this.itemsPer2 : this.itemsPer1));
            let x=this.SS['s' + v ];
            let a=P.find(per => per.id==Number(x));
            console.log('*turno_change',v,x,a);

            this.SS['s'+ v +'t']=a.tph;
            this.SS['s'+ v +'tx']=(a.tp==1?'Habit.':'Apart.');
            this.SS['s'+ v +'h1']=1;
            this.SS['s'+ v +'e']=a.fhe;
            this.SS['s'+ v +'s']=a.fhs;
            this.SS['s'+ v +'r']=a.reg;
            this.SS['s'+ v +'pp']=a.mpax;
            this.SS['s'+ v +'pa']=a.madu;

        },

        async precios() {
            if (!this.SS.s1>'') {
                this.modal({tit: this.plan, msg: "Debes seleccionar algún periodo, para el cálculo de Precios ..."});
                return;
            }

            if (!this.validar()) return;

            //this.$store.state.calculo=[];
            this.SS.adu=this.PAX.adu;
            this.SS.nin=this.PAX.nin;
            this.SS.bbs=this.PAX.bbs;
            this.SS.adug=this.PAX.adug; this.SS.ning=this.PAX.ning;

            let args={ token: this.auth.token, fnt:'precios', plan: this.planId, SOL: this.SS}
            let r=await this.exec({api:'solicitud', arg: args });

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                this.modal({tit: this.plan, msg: r.datos});
                return;
            }
            console.log("*precios",r.datos);

            this.$store.state.calculo=this.$util.object_array(r.datos[0]);

            this.$bvModal.show("modal_precios");
            //this.$router.push('/');
        },

   }
}
</script>